// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__8Ub-a","contactContent":"Contact_contactContent__MLC5Z","title":"Contact_title__ANrXy","link":"Contact_link__L+6Y3"};